/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import CopyTextM from '../elements/CopyTextM';
import { useResponsive } from '../../hooks/responsive';
import './newsfeed-news-teaser.scss';
import Headline from '../elements/Headline';

const NewsfeedNewsTeaser = (props) => {
  const { type, content, title, intro, linkPath, linkText, onClickDetails, linkTarget } = props;
  const { isMobile } = useResponsive();

  // If wysiwyg, just print raw HTML from content
  if (type === 'wysiwyg') {
    return (
      <div className="bt-newsfeed-news-teaser">
        <CopyTextM text={content} />
      </div>
    );
  }

  return (
    <div className="bt-newsfeed-news-teaser">
      {isMobile ? (
        <a
          target={linkTarget}
          href={linkPath}
          title={linkText}
          onClick={onClickDetails}
          className="bt-newsfeed-news-teaser__headlinelink"
        >
          <Headline level={3} as="h2" text={title} />
        </a>
      ) : (
        <a
          target={linkTarget}
          href={linkPath}
          title={linkText}
          onClick={onClickDetails}
          className="bt-newsfeed-news-teaser__headlinelink"
        >
          <Headline level={3} as="h2" text={title} />
          <p className="bt-newsfeed-news-teaser__intro">
            <CopyTextM text={intro} />
          </p>
        </a>
      )}

      <p className="bt-newsfeed-news-teaser__link">
        <a href={linkPath} onClick={onClickDetails} target={linkTarget}>
          {linkText}
        </a>
      </p>
    </div>
  );
};

NewsfeedNewsTeaser.propTypes = {
  type: PropTypes.string,
  content: PropTypes.string,
  title: PropTypes.string,
  intro: PropTypes.string,
  linkPath: PropTypes.string,
  linkText: PropTypes.string,
  onClickDetails: PropTypes.func,
  onClickShowDocuments: PropTypes.func,
  linkTarget: PropTypes.string,
};

NewsfeedNewsTeaser.defaultProps = {
  type: 'post',
  content: '',
  title: '',
  intro: '',
  linkPath: '',
  linkText: '',
  onClickDetails: () => false,
  onClickShowDocuments: () => false,
  linkTarget: '_self',
};

export default NewsfeedNewsTeaser;
